import { Table } from '@octano/global-ui';
import { SectionTitle } from '../../../../components/text';
import { Base } from '../../types';
import { useColumns } from './hooks/useColumns';

type Props = {
  studyPlanEnrollmentId: number;
  documents: Base['degreeDocuments'];
  texts: {
    title: string;
    selectOptions: {
      rejected: string;
      approved: string;
      pending: string;
    };
    toasts: {
      upload: {
        success: string;
        failed: string;
      };
      remove: {
        success: string;
        failed: string;
      };
      editStatus: {
        success: string;
        failed: string;
      };
      confirmDelete: {
        title: string;
        description: string;
        confirm: string;
        cancel: string;
      };
    };
    table: {
      noResults: string;
      headers: {
        name: string;
        documentName: string;
        load: string;
        state: string;
      };
      values: {
        loadButton: string;
      };
    };
  };
  refresh: Function;
  disableEditing?: boolean;
};

export function DegreeDocuments({
  studyPlanEnrollmentId,
  documents,
  texts,
  refresh,
  disableEditing = false,
}: Props) {
  const columns = useColumns(
    studyPlanEnrollmentId,
    texts,
    refresh,
    disableEditing,
  );
  return (
    <>
      <SectionTitle text={texts.title} />
      <div className="mb-4" />
      <Table
        columns={columns}
        data={documents}
        noResultsText={texts.table.noResults}
      />
    </>
  );
}
